import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { NewUser, Profile, User } from '../model/models'

export class UserAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.userList = this.userList.bind(this)
  }

  public userList(): Promise<User[]> {
    const endpoint = '/admin/user/?ordering=id'
    return this.get<User[]>(endpoint)
      .then((response: AxiosResponse<User[]>) => response.data)
      .catch((error) => Promise.reject(error))
  }

  public addUser(user: NewUser): Promise<User> {
    const endpoint = `/admin/user/`
    return this.post<User, NewUser>(endpoint, user)
      .then((response: AxiosResponse<User>) => response.data)
      .catch((error: Error | AxiosError) => {
        throw error
      })
  }

  public updateUserIsActive(user: User): Promise<User> {
    const endpoint = `/admin/user/${user.id}/`
    return this.put<User, { isActive: boolean }>(endpoint, {
      isActive: !user.isActive,
    })
      .then((response: AxiosResponse<User>) => response.data)
      .catch((error: Error | AxiosError) => {
        throw error
      })
  }

  public deleteUser(id: string): Promise<User[]> {
    const endpoint = `/admin/user/${id}/`
    return this.delete<User[]>(endpoint)
      .then((response: AxiosResponse<User[]>) => response.data)
      .catch((error: Error | AxiosError) => {
        throw error
      })
  }

  public updateProfile(email: string, profile: Profile): Promise<number> {
    const endpoint = `/user/update_profile/`
    return this.post<number, { email: string; profile: Profile }>(endpoint, {
      email,
      profile,
    })
      .then((response: AxiosResponse<number>) => response.status)
      .catch((error: Error | AxiosError) => {
        throw error
      })
  }
}

export const userAPI = new UserAPI(httpConfig)
